
import { MenuItemProps, useTranslations } from "@mzara/component"
import { useMemo } from "react"
import { useKanbanCardDetailsQuery } from "../../../hooks/useKanbanCardDetailsQuery"

export const useKanbanCardDetailsMenu = (boardId: number, num: number) => {

    const [
        COPY_LINK,
        ARCHIVE,
        DELETE,
        CLOSE,
        OPEN,
        UN_ARCHIVE,
    ] = useTranslations(i18n)
    const { data } = useKanbanCardDetailsQuery(boardId, num, true);

    return useMemo((): Array<MenuItemProps> => ([
        {
            ke: 'copy-link',
            label: COPY_LINK,
        },
        {
            divide:true
        },
        data.isClosed && !data.dateArchive ? {
            ke: 'open',
            label: OPEN,
        } : null,
        !data.isClosed && !data.dateArchive ? {
            ke: 'close',
            label: CLOSE,
        } : null,
        !data.dateArchive ? {
            ke: 'archive',
            label: ARCHIVE,
        } : null,
        data.dateArchive ? {
            ke: 'unarchive',
            label: UN_ARCHIVE,
        } : null,
        data.isDeletable ? {
            ke: 'delete',
            label: DELETE,
        } : null,
    ]), [COPY_LINK, data])
}

const i18n = [
    "std_copy_link",
    "std_archive",
    "std_delete",
    'std_close',
    'std_open',
    'std_unarchive'
]

